import { ChevronLeft, ChevronRight } from 'lucide-react';

import { Button } from './button';

type PaginationProps = {
  isBackDisabled?: boolean;
  isForwardDisabled?: boolean;
  onMoveForward: () => void;
  onMoveBackward: () => void;
};

export function Pagination(props: PaginationProps) {
  const {
    onMoveForward,
    onMoveBackward,
    isBackDisabled = false,
    isForwardDisabled = false,
  } = props;

  return (
    <div className="flex justify-center items-center gap-4">
      <Button variant="ghost" size="icon" onClick={onMoveBackward} disabled={isBackDisabled}>
        <ChevronLeft className="h-5 w-5" />
      </Button>

      <Button variant="ghost" size="icon" onClick={onMoveForward} disabled={isForwardDisabled}>
        <ChevronRight className="h-5 w-5" />
      </Button>
    </div>
  );
}
